import React from 'react';

const ExcludeButton = ({ onClick }) => {
  return (
    <button className="exclude-btn" onClick={onClick}>
      Exclude
    </button>
  );
};

export default ExcludeButton;
